import { Injectable, Inject } from "@angular/core";
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { IFormAuthorizationForDisclosure } from "../Models/Forms/IFormAuthorizationForDisclosure";
import { BaseService } from './BaseService';

@Injectable()
export class FormAuthorizationForDisclosureService extends BaseService {
  _baseUrl: string = "";

  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getFormAuthorizationForDisclosure(id: number) {
    return this._http.get(this._baseUrl + "api/FormAuthorizationForDisclosure/" + id)
      .map((response: IFormAuthorizationForDisclosure) => response as IFormAuthorizationForDisclosure)
      .catch(this.errorHandler);
  }

  insertUpdateFormAuthorizationForDisclosure(formAuthorizationForDisclosureDetails: IFormAuthorizationForDisclosure) {
    return this._http.post(this._baseUrl + 'api/FormAuthorizationForDisclosure', formAuthorizationForDisclosureDetails)
      .map((response: IFormAuthorizationForDisclosure) => response as IFormAuthorizationForDisclosure)
      .catch(this.errorHandler);
  }

  deleteAuthorizationForDisclosure(id) {
    return this._http.delete(this._baseUrl + "api/FormAuthorizationForDisclosure" + id)
      .map((response: IFormAuthorizationForDisclosure) => response as IFormAuthorizationForDisclosure)
      .catch(this.errorHandler)
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }

}

